import { compact } from 'lodash';
import { filterEmptyValues } from 'libs/utils/object';
export const searchDtoToUrlParams = search => {
  var _search$price_from, _search$price_to, _search$price_from2, _search$price_to2;

  const {
    search_text
  } = search;
  const disposal = ['is_for_sell'].filter(option => search[option]).map(option => "search_".concat(option));
  const params = {
    search_text,
    brand_ids: search.brands.map(it => it.id),
    color_ids: search.color_ids,
    size_ids: search.size_ids,
    status_ids: search.status_ids,
    catalog: compact([search.catalog_id]),
    material_ids: search.material_ids,
    video_game_rating_ids: search.video_game_rating_ids,
    disposal: compact(disposal),
    price_from: (_search$price_from = search.price_from) === null || _search$price_from === void 0 ? void 0 : _search$price_from.amount,
    price_to: (_search$price_to = search.price_to) === null || _search$price_to === void 0 ? void 0 : _search$price_to.amount,
    currency: ((_search$price_from2 = search.price_from) === null || _search$price_from2 === void 0 ? void 0 : _search$price_from2.currency_code) || ((_search$price_to2 = search.price_to) === null || _search$price_to2 === void 0 ? void 0 : _search$price_to2.currency_code)
  };
  return filterEmptyValues(params);
};